import { render, staticRenderFns } from "./StreamerCreatorPageBuilder.vue?vue&type=template&id=8b06bc10&"
import script from "./StreamerCreatorPageBuilder.vue?vue&type=script&lang=js&"
export * from "./StreamerCreatorPageBuilder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports